import rawPhotos from '../json/resimler.json';
import { db } from '../firebase';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';

let _cache = null;

function cleanImageUrl(url) {
  try {
    if (!url) return '';
    return url
      .replaceAll('Ç', 'C').replaceAll('ç', 'c')
      .replaceAll('Ğ', 'G').replaceAll('ğ', 'g')
      .replaceAll('İ', 'I').replaceAll('ı', 'i')
      .replaceAll('Ö', 'O').replaceAll('ö', 'o')
      .replaceAll('Ş', 'S').replaceAll('ş', 's')
      .replaceAll('Ü', 'U').replaceAll('ü', 'u')
      .replaceAll(' ', '-')
      .replaceAll('(', '')
      .replaceAll(')', '');
  } catch (e) {
    return url || '';
  }
}

function parseDate(d) {
  if (!d) return new Date();
  try {
    return new Date(String(d).replace(' ', 'T'));
  } catch {
    return new Date();
  }
}

function extractLocation(title) {
  const t = (title || '').toUpperCase();
  if (!t) return null;
  if (t.includes('KÖYÜ')) return `${t.split(' ')[0]} KÖYÜ`;
  if (t.includes('MAHALLE')) return `${t.split(' ')[0]} MAHALLESİ`;
  return t;
}

// phpMyAdmin table formatını da destekle
function unwrapPhpMyAdminIfNeeded(jsonLike) {
  if (Array.isArray(jsonLike)) {
    const table = jsonLike.find(
      (it) => it && typeof it === 'object' && it.type === 'table' && Array.isArray(it.data)
    );
    if (table) return table.data;
    return jsonLike;
  }
  return [];
}

function shape(photoJson) {
  const postType = String(photoJson?.post_type ?? '');
  const isAttachment = postType === 'attachment';
  const guid = cleanImageUrl(String(photoJson?.guid ?? ''));
  const title = String(photoJson?.post_title ?? '');

  return {
    id: String(photoJson?.ID ?? ''),
    title: title,
    description: photoJson?.post_content ? String(photoJson.post_content) : undefined,
    imageUrl: guid,
    postType,
    uploadDate: parseDate(photoJson?.post_date),
    location: extractLocation(title),
    isValid: isAttachment && !!guid && !!title
  };
}

export async function getPhotos() {
  if (_cache) return _cache;

  // 1) JSON kaynağı (mevcut mantık aynen)
  const rows = unwrapPhpMyAdminIfNeeded(rawPhotos);
  const jsonPhotos = [];
  for (const row of rows) {
    if (!row || typeof row !== 'object') continue;
    try {
      const p = shape(row);
      if (p.isValid) jsonPhotos.push({ ...p, source: 'json' });
    } catch {}
  }

  // 2) Firebase kaynağı
  let fbPhotos = [];
  try {
    const q = query(collection(db, 'resimler'), orderBy('createdAt', 'desc'));
    const snap = await getDocs(q);
    fbPhotos = snap.docs.map(doc => {
      const d = doc.data();
      return {
        id: doc.id,
        title: d.title || '',
        description: d.description || '',
        imageUrl: d.imageUrl || '',
        location: d.location || extractLocation(d.title),
        uploadDate: d.createdAt?.toDate?.() ?? new Date(0),
        source: 'fb',
        isValid: true,
      };
    });
  } catch (e) {
    console.warn('Firebase resimler yüklenemedi:', e);
  }

  // 3) Birleştir — FB önce (yeni eklenenler üstte), sonra JSON
  const merged = [...fbPhotos, ...jsonPhotos];
  merged.sort((a, b) => b.uploadDate - a.uploadDate);

  _cache = merged;
  return _cache;
}

export async function getLatestPhotos(limit = 20) {
  const all = await getPhotos();
  return all.slice(0, limit);
}

export function clearPhotosCache() {
  _cache = null;
}
